import { ChangeDetectorRef, Component, forwardRef, Inject, OnInit, Optional } from '@angular/core';
import { DateAdapter, MatDateFormats, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { getYear } from 'date-fns';

@Component({
  selector: 'app-a-mat-calendar-header',
  templateUrl: './a-mat-calendar-header.component.html',
  styleUrls: ['./a-mat-calendar-header.component.scss']
})
export class AMatCalendarHeaderComponent<D> implements OnInit {

  view: string = "";

  //seed year
  currentYear?: number;
  selectYear: number;

  constructor(
    @Inject(forwardRef(() => MatCalendar)) public calendar: MatCalendar<D>,
    @Optional() private _dateAdapter: DateAdapter<D>,
    @Optional() @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
    changeDetectorRef: ChangeDetectorRef) {
    this.calendar.stateChanges.subscribe((v) => {
      changeDetectorRef.markForCheck();
    }
    );
  }

  ngOnInit(): void {
  }

  nextMonth() {
    this.calendar.activeDate = this._dateAdapter.addCalendarMonths(this.calendar.activeDate, 1)
  }
  previousMonth() {
    this.calendar.activeDate = this._dateAdapter.addCalendarMonths(this.calendar.activeDate, -1)
  }

  nextYear() {
    this.calendar.activeDate = this._dateAdapter.addCalendarYears(this.calendar.activeDate, 1);
  }

  previousYear() {
    this.calendar.activeDate = this._dateAdapter.addCalendarYears(this.calendar.activeDate, -1);
  }

  nextMonthEnabled(): boolean {
    return !this.calendar.maxDate ||
      !this._isSameMonth(this.calendar.activeDate, this.calendar.maxDate);
  }

  previousMonthEnabled(): boolean {
    if (!this.calendar.minDate) {
      return true;
    }
    return !this._isSameMonth(this.calendar.activeDate, this.calendar.minDate);
  }

  nextYearEnabled(): boolean {
    return !this.calendar.maxDate ||
      !this._isSameYear(this.calendar.activeDate, this.calendar.maxDate);
  }

  previousYearEnabled(): boolean {
    if (!this.calendar.minDate) {
      return true;
    }
    return !this._isSameYear(this.calendar.activeDate, this.calendar.minDate);
  }

  private _isSameMonth(date1: D, date2: D): boolean {
    return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2) &&
      this._dateAdapter.getMonth(date1) == this._dateAdapter.getMonth(date2);
  }

  /** Whether the two dates represent the same view in the current view mode (month or year). */
  private _isSameYear(date1: D, date2: D): boolean {
    if (this.calendar.currentView == 'month') {
      return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2) &&
        this._dateAdapter.getMonth(date1) == this._dateAdapter.getMonth(date2);
    }
    if (this.calendar.currentView == 'year') {
      return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2);
    }
  }
  onYearSelected(event) {
    this.selectYear = event;
    this.currentYear = undefined;
    this.view = "month";
  }

  onMonthSelected(event) {
    this.view = "";
    this.calendar.activeDate = event;
  }

  backToYearView(event) {
    this.currentYear = getYear(event);
    this.view = 'year';
  }

  onYearClick() {
    this.view = 'year';
    this.selectYear = getYear(this.calendar.activeDate as any);
  }

  onMonthClick() {
    this.view = 'month';
    this.selectYear = getYear(this.calendar.activeDate as any);
  }
}
